import { useEffect, useState } from "react";
import translations from "../libs/i18n/Translations";
export default function useI18nInit(defaultLanguage, pathsList) {
    const [state, setState] = useState({
        language: (window === null || window === void 0 ? void 0 : window.localStorage.getItem("language")) || defaultLanguage,
        status: "pending",
    });
    translations.init(pathsList);
    useEffect(() => {
        async function load() {
            try {
                await translations.load(state.language);
                setState((s) => ({ ...s, status: "ok" }));
            }
            catch (error) {
                console.error(error);
                setState((s) => ({ ...s, status: "error" }));
            }
        }
        load();
    }, [state.language]);
    return {
        state,
        setState,
    };
}
